import * as React from "react";
import { Alert, Card, Divider } from "antd";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { CardContent } from "../../components/antd/card/CardContent";
import { CardCollapsibleContent } from "../../components/antd/card/CardCollapsibleContent";
import { v4 as uuidv4 } from "uuid";
import { SecretTypeTag } from "../../components/antd/kindselect/tagRenderers/secretTypeTag";
import { useCpFormValue } from "../gvc/testNewForm/utils";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpSwitch } from "../gvc/testNewForm/CpSwitch";
import { CpSelect } from "../gvc/testNewForm/CpSelect";
import { CpInput } from "../gvc/testNewForm/CpInput";
import { CpArrayObject } from "../gvc/testNewForm/CpArrayObject";
import { CpArrayItemNameValuePair } from "../workload/draft/CpArrayItemNameValuePair";
import { CpKindSelect } from "../gvc/testNewForm/temp/CpKindSelect";
import { CpLabelTooltip } from "../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../gvc/testNewForm/CpTooltip";

interface Props {}
export const Tracing: React.FC<Props> = ({}) => {
  const isEnabled = useCpFormValue(`tracing.isEnabled`);
  const tracing = useCpFormValue(`tracing`);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>Tracing</CardTitle>
          <CardContent>
            <Alert
              className="mb-4 w-fit"
              type={"warning"}
              showIcon
              message={`Changing the tracing causes a redeployment for all workloads in this org.`}
            />
            <CpFormItem>
              <div className="flex items-center gap-2">
                <CpLabel name={`tracing.isEnabled`}>Enable Tracing</CpLabel>
                <CpSwitch name={`tracing.isEnabled`} />
              </div>
            </CpFormItem>
            <CardCollapsibleContent collapsed={!isEnabled}>
              <CpFormItem>
                <CpLabel name={`tracing.provider`}>Provider</CpLabel>
                <CpSelect
                  style={{ width: 600 }}
                  name={`tracing.provider`}
                  options={[
                    { label: "Control Plane", value: "controlplane" },
                    { label: "Lightstep", value: "lightstep" },
                    { label: "Open Telemetry", value: "otel" },
                  ]}
                />
              </CpFormItem>
              <CpFormItem>
                <CpLabel name={`tracing.sampling`}>Sampling Percentage</CpLabel>
                <CpInput style={{ width: 600 }} name={`tracing.sampling`} />
              </CpFormItem>
              <CpArrayObject
                factoryFn={() => ({ id: uuidv4(), name: "", value: "" })}
                label="Custom Tags"
                labels={["Key", "Value"]}
                name={`tracing.customTags`}
              >
                <CpArrayItemNameValuePair />
              </CpArrayObject>
              {tracing.provider === "lightstep" ? (
                <>
                  <Divider orientation={"left"} orientationMargin={0}>
                    Lightstep
                  </Divider>
                  <CpFormItem>
                    <CpLabelTooltip>
                      <CpLabel name={`tracing.lightstep.credentialsSecret`}>Credentials</CpLabel>
                      <CpTooltip tooltipProps={{ title: "Must be an opaque secret" }} />
                    </CpLabelTooltip>
                    <CpKindSelect
                      kind="secret"
                      name={`tracing.lightstep.credentialsSecret`}
                      optionValue="name"
                      queries={[{ property: "type", value: "opaque" }]}
                      tagRenderers={[SecretTypeTag] as any}
                      style={{ maxWidth: 600 }}
                    />
                  </CpFormItem>
                  <CpFormItem>
                    <CpLabelTooltip>
                      <CpLabel name={`tracing.lightstep.endpoint`}>Endpoint</CpLabel>
                      <CpTooltip
                        tooltipProps={{ title: "Values can be: test.com, <workload>.<gvc>.cpln.local[:<port>]" }}
                      />
                    </CpLabelTooltip>
                    <CpInput name={`tracing.lightstep.endpoint`} style={{ maxWidth: 600 }} />
                  </CpFormItem>
                </>
              ) : null}
              {tracing.provider === "otel" ? (
                <>
                  <Divider orientation={"left"} orientationMargin={0}>
                    Open Telemetry
                  </Divider>
                  <CpFormItem>
                    <CpLabelTooltip>
                      <CpLabel name={`tracing.otel.endpoint`}>Endpoint</CpLabel>
                      <CpTooltip
                        tooltipProps={{ title: "Values can be: test.com, <workload>.<gvc>.cpln.local[:<port>]" }}
                      />
                    </CpLabelTooltip>
                    <CpInput name={`tracing.otel.endpoint`} style={{ maxWidth: 600 }} />
                  </CpFormItem>
                </>
              ) : null}
            </CardCollapsibleContent>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
